import React, { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { FeedbackDrawer } from '../Feedback/FeedbackDrawer';
import { ThemeToggle } from '../ThemeToggle';

export function Header({ onSignOut, onMenuClick }) {
  const { user } = useAuth();
  const userEmail = user?.signInDetails?.loginId || 'User';
  const [feedbackOpen, setFeedbackOpen] = useState(false);

  return (
    <header className="bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-800 px-4 sm:px-6 py-3 sm:py-4">
      <div className="flex items-center justify-between gap-2">
        {/* Mobile hamburger + page subtitle */}
        <div className="flex items-center gap-2 min-w-0">
          <button
            type="button"
            onClick={onMenuClick}
            aria-label="Open navigation"
            className="lg:hidden -ml-2 p-2 inline-flex items-center justify-center w-11 h-11 text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
          <p className="hidden sm:block text-sm text-gray-500 dark:text-gray-400 truncate">
            Your pricing intelligence, based on your past jobs.
          </p>
        </div>

        {/* User menu */}
        <div className="flex items-center gap-2 sm:gap-4">
          {/* Theme toggle */}
          <ThemeToggle />

          {/* Feedback / report bug */}
          <button
            type="button"
            onClick={() => setFeedbackOpen(true)}
            aria-label="Send feedback"
            title="Send feedback"
            className="p-2 text-gray-400 hover:text-gray-600 dark:text-gray-300 dark:hover:text-white transition-colors"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M9 3h6l1 3h3v3l-2 1v4l2 1v3h-3l-1 3H9l-1-3H5v-3l2-1v-4L5 9V6h3l1-3z" />
            </svg>
          </button>

          {/* Notifications placeholder */}
          <button className="relative p-2 text-gray-400 hover:text-gray-600 dark:text-gray-300 dark:hover:text-white transition-colors">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
            </svg>
          </button>

          {/* User dropdown */}
          <div className="flex items-center gap-3 md:pl-4 md:border-l border-gray-200 dark:border-gray-700">
            <div className="hidden md:block text-right">
              <p className="text-sm font-medium text-gray-700 dark:text-gray-200">{userEmail}</p>
            </div>
            <button
              onClick={onSignOut}
              className="text-sm text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 transition-colors"
            >
              Sign out
            </button>
          </div>
        </div>
      </div>

      <FeedbackDrawer open={feedbackOpen} onClose={() => setFeedbackOpen(false)} />
    </header>
  );
}

export default Header;
